export const FORM_PAGES_NUMBERS = {
    subscriptionDetails: 0,
    medicalForm: 1,
    contactDetails: 2,
    summaryPage: 3,
    subscriptionPlaced: 4,
};

export const FORM_PAGES_LABELS = [
    'Szczegóły subskrypcji',
    'Formularz dopasowujący ',
    'Dane kontaktowe',
    'Podsumowanie',
];
